module.exports = __webpack_public_path__ + "static/img/car_6_8_box@3x.c9f7daf9.png";